import { useState } from "react";
import type { ActorDTO } from "@roomate/core";
import { keys, usePatch } from "../api.ts";
import { Button, ErrorNote } from "../ui.tsx";

/** Admin removes a person from the room. History stays; the server refuses the last active admin. */
export function RemoveMemberButton({ actor }: { actor: ActorDTO }) {
  const patch = usePatch<ActorDTO>([keys.actors]);
  const [confirm, setConfirm] = useState(false);
  if (!confirm) {
    return (
      <Button variant="ghost" className="px-2 text-[12px]" data-testid="remove-member" onClick={() => setConfirm(true)}>
        Remove
      </Button>
    );
  }
  return (
    <span className="flex flex-wrap items-center gap-1">
      <Button
        variant="danger"
        className="px-2 text-[12px]"
        data-testid="remove-member-confirm"
        disabled={patch.isPending}
        onClick={() => patch.mutate({ path: `/actors/${actor.id}`, body: { archived: true } })}
      >
        Remove {actor.name}
      </Button>
      <Button variant="ghost" className="px-2 text-[12px]" onClick={() => setConfirm(false)}>
        Cancel
      </Button>
      <ErrorNote error={patch.error} />
    </span>
  );
}

/** Admin puts a removed person back. Their old tokens stay revoked. */
export function RestoreMemberButton({ actor }: { actor: ActorDTO }) {
  const patch = usePatch<ActorDTO>([keys.actors]);
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <Button
        variant="ghost"
        className="px-2 text-[12px]"
        data-testid="restore-member"
        disabled={patch.isPending}
        onClick={() => patch.mutate({ path: `/actors/${actor.id}`, body: { archived: false } })}
      >
        Restore
      </Button>
      <ErrorNote error={patch.error} />
    </span>
  );
}
